// import "./SignUp.scss";
import "../../assets/sass/components/signUp/_signUp.scss";

import React, { useContext, useEffect, useState } from "react";
import { Redirect, useLocation } from "react-router-dom";
// import momentTZ from "moment-timezone";
import { Trans } from "react-i18next";

import routes from "../../constants/Routes";
import authService from "../../services/AuthService";
import GLOBAL from "../../global";
import AppContext from "../../contexts/AppContext";
import CONSTANT from "../../constants/Constant";
import DisplayUrlContent from "../shared/DisplayUrlContent";
import { getUserIdentification, makeSerializable, prepareEnabledSubscribedFeatures, isMobileDevice } from "../../utils/Utils";
import SignUp1 from "./SignUp1";
import AthleteSignUp from "./AthleteSignUp";
import { invalidFormElement } from "../../utils/DefaultInitialization";
import CreditCardForm from "./CreditCardForm";
import storageService from "../../utils/StorageService";
import useRedirect from "../../hooks/useRedirect";
import usePaymentAndD2CRedirection from "../../hooks/usePaymentAndD2CRedirection";
import useD2C from "../../hooks/useD2C";
import { useHandleDirectPayment } from "../../contexts/DirectPaymentContext";
import { setEventData } from "../../features/askEmma/askEmmaSlice";
import { useDispatch } from "react-redux";
import AlertModal from "../shared/AlertModal";
import MobileAppSuggestionsModal from "../MobileAppSuggestions/MobileAppSuggestionsModal";
import { useTenantFeatures } from "../../features/tenantFeatures/useTenantFeature";
import useDeviceCompatibility from "../../hooks/useDeviceCompatibility";
// import cardService from "../../services/CardService";

function SignUp(props) {
    const { authenticate, deAuthenticate, storeUserInfo, storeUserInfoToLocalStorage } = useContext(AppContext);
    const [redirectToDashboard, setRedirectToDashboard] = useState(false);
    const [signUpCreated, setSignUpCreated] = useState(false);
    const [termOfServiceModal, setTermOfServiceModal] = useState(false);
    const [privacyPolicyModal, setPrivacyPolicyModal] = useState(false)
    const [errorMessage, setErrorMessage] = useState('');
    const [showCreditCardForm, setShowCreditCardForm] = useState(false);
    const [showMobileAppSuggestion, setShowMobileAppSuggestion] = useState(false);

    const { redirectKeepingQueryParams } = useRedirect();
    const location = useLocation();
    const { isValidUrlForD2C } = usePaymentAndD2CRedirection();
    const { IsD2CEnabled } = useD2C();
    const {
        email: directPaymentUserEmail,
        isNewUserFromDirectPayment,
    } = useHandleDirectPayment();

    const dispatch = useDispatch();
    const { isAthleteEnabled } = useTenantFeatures();
    const { isMobileAppSuggestionModalEnabled } = useDeviceCompatibility();
    const query = new URLSearchParams(location?.search);
    const sessionId = query.get('session_id');

    const onSubmitSignUp = async (values, setIsSubmitting) => {
        setIsSubmitting(true);
        setErrorMessage('');

        let query = new URLSearchParams(location?.search);
        let packageIdFromUrl = query.get(CONSTANT.QUERY_PARAM.PACKAGE_ID) || '';
        let sessionId = query.get('session_id') || '';

        const tempValues = { ...values };
        tempValues.EmailAddress = tempValues.Email;
        tempValues.BillingEmail = tempValues.BillingEmail;
        tempValues.TimeZone = tempValues.TimeZone;
        tempValues.Height = +tempValues.height_feet * 12 + +tempValues.height_inch;
        delete tempValues.height_feet
        delete tempValues.height_inch
        tempValues.InvId = GLOBAL.URL_PARAMS.INVITATION_ID;

        if (sessionId) {
            tempValues.SessionId = sessionId;
        }

        delete tempValues.Email;
        delete tempValues.AcceptTerms;
        delete tempValues.UseSameEmailForAthleteAccount;

        tempValues.IsD2CRegister = isValidUrlForD2C() || isNewUserFromDirectPayment || !!directPaymentUserEmail;
        tempValues.PackageId = packageIdFromUrl;


        const response = await authService.register(tempValues);
        const { data, success, error } = response;

        if (!success) {
            setErrorMessage(error);
            setIsSubmitting(false);
            return;
        }

        storageService.addItem(CONSTANT.JWT.TOKEN_KEY, data?.Token);
        storageService.addItem(CONSTANT.REFRESH_TOKEN.KEY_NAME, data?.RefreshToken);

        const userInfo = data || '{}';
        const isProvider = userInfo['RoleName'] === CONSTANT.ROLE.PROVIDER;

        const subscriptionFeatures = await getSubscriptionFeatures(userInfo, isProvider);
        userInfo.Permissions = prepareEnabledSubscribedFeatures(subscriptionFeatures) || {};


        setIsSubmitting(false);
        setSignUpCreated(true);
        GLOBAL.USER_INFO = userInfo;
        storeUserInfo(GLOBAL.USER_INFO);
        storeUserInfoToLocalStorage();
        authenticate(true);

        dispatch(setEventData({ eventName: 'patientPortal_RegistrationSuccess' }))

        if (isMobileAppSuggestionModalEnabled && isMobileDevice()) {
            setShowMobileAppSuggestion(true);
            return;
        }

        if (isValidUrlForD2C()) {
            storageService.addItem(CONSTANT.IS_D2C_USER.KEY, true);
        } else {
            storageService.removeItem(CONSTANT.IS_D2C_USER.KEY);
        }

        let currentUrl = window.location.href;

        if (IsD2CEnabled && currentUrl.includes('package')) {
            return;
        }

        if (!GLOBAL?.IS_SUBSCRIPTION_ENABLED) {
            setRedirectToDashboard(true);
        } else {
            setShowCreditCardForm(true);
        }
    };

    const getSubscriptionFeatures = async (userInfo, isProvider) => {
        let role = '';
        if (isProvider) {
            role = 'ReferringProvider'
        } else {
            role = 'Patient'
        }
        const payload = { Role: role }
        const response = await authService.getSubscriptionFeature(payload);
        const { data, success, error } = response;

        if (!success) {
            console.error(error)
            return;
        }

        const subscriptionFeatures = data || '{}';
        GLOBAL.SUBSCRIPTION_FEATURES = subscriptionFeatures.Features;
        return subscriptionFeatures.Features;
    }

    const onClickSignIn = (e) => {
        e.preventDefault();
        redirectKeepingQueryParams(routes.signIn);
    };

    const onClickTermOfServiceToggle = (e) => {
        e.preventDefault();
        setTermOfServiceModal(!termOfServiceModal);
    };

    useEffect(() => {
        deAuthenticate();

        // eslint-disable-next-line
    }, []);

    if (redirectToDashboard) {
        if (isAthleteEnabled) {
            return <Redirect to={`${routes.myAssessments}/false`} />;
        } else {
            return <Redirect to={`${routes.dashboard}`} />;
        }
    }

    const onClickPrivacyPolicyToggle = (e) => {
        e.preventDefault();
        setPrivacyPolicyModal(prevState => !prevState);
    }

    const handleOnClickAreYouRegistered = (e) => {
        e?.preventDefault();
        props?.onClickRedirectToSignIn
            ? props.onClickRedirectToSignIn()
            : redirectKeepingQueryParams(routes.signIn);
    }

    const onCancelMobileAppSuggestion = () => {
        setShowMobileAppSuggestion(false);

        if (isValidUrlForD2C()) {
            storageService.addItem(CONSTANT.IS_D2C_USER.KEY, true);
        } else {
            storageService.removeItem(CONSTANT.IS_D2C_USER.KEY);
        }

        let currentUrl = window.location.href;

        if (IsD2CEnabled && currentUrl.includes('package')) {
            return;
        }

        if (!GLOBAL?.IS_SUBSCRIPTION_ENABLED) {
            setRedirectToDashboard(true);
        } else {
            setShowCreditCardForm(true);
        }
    };

    // noinspection CheckTagEmptyBody
    return (
        <div className={"mmh-center-item-flex"}>
            <div className="mmh-center-item-flex">
                {!showCreditCardForm
                    ? (
                        isAthleteEnabled ? (
                            <AthleteSignUp
                                onSubmitSignUp={onSubmitSignUp}
                                invalidFormElement={invalidFormElement}
                                onClickTermOfServiceToggle={onClickTermOfServiceToggle}
                                onClickPrivacyPolicyToggle={onClickPrivacyPolicyToggle}
                                signUpCreated={signUpCreated}
                                errorMessage={errorMessage}
                                setErrorMessage={setErrorMessage}
                                isD2CRegistration={isValidUrlForD2C()}
                                imgComponent={props.imgComponent}
                                logoComponent={props.logoComponent}
                                handleOnClickAreYouRegistered={handleOnClickAreYouRegistered}
                                setEmailToLoadInitiallyAtSignIn={props?.setEmailToLoadInitiallyAtSignIn}
                            />
                        ) : (
                            <SignUp1
                                onSubmitSignUp={onSubmitSignUp}
                                invalidFormElement={invalidFormElement}
                                onClickTermOfServiceToggle={onClickTermOfServiceToggle}
                                onClickPrivacyPolicyToggle={onClickPrivacyPolicyToggle}
                                signUpCreated={signUpCreated}
                                errorMessage={errorMessage}
                                setErrorMessage={setErrorMessage}
                                isD2CRegistration={isValidUrlForD2C()}
                                imgComponent={props.imgComponent}
                                logoComponent={props.logoComponent}
                                handleOnClickAreYouRegistered={handleOnClickAreYouRegistered}
                                setEmailToLoadInitiallyAtSignIn={props?.setEmailToLoadInitiallyAtSignIn}
                            >
                                <div className="text-center cursor-pointer"
                                    onClick={handleOnClickAreYouRegistered}>
                                    <span>
                                        Are you a registered {getUserIdentification()}?
                                    </span>
                                    &nbsp;&nbsp;
                                    <a
                                        href={"!#"}
                                        rel="noopener noreferrer"
                                        className="signin-signup-link">
                                        <Trans i18nKey="common.form.sign-in" />
                                    </a>


                                </div>
                            </SignUp1>
                        )
                    ) : (
                        <CreditCardForm
                        // onSubmitCreditCardForm={onSubmitCreditCardForm}
                        // invalidFormElement={invalidFormElement}
                        // errorMessage={errorMessage}
                        >
                        </CreditCardForm>
                    )
                }

            </div>
            {termOfServiceModal && (
                <DisplayUrlContent
                    open={termOfServiceModal}
                    url={`https://${GLOBAL.TENANT}.injurycloud.com/account/termsofservice`}
                    onToggleModal={onClickTermOfServiceToggle}>
                </DisplayUrlContent>
            )}
            {privacyPolicyModal && (
                <DisplayUrlContent
                    headerTitle={"Privacy Policy"}
                    open={privacyPolicyModal}
                    url={`https://${GLOBAL.TENANT}.injurycloud.com/account/privacypolicy`}
                    onToggleModal={(e) => onClickPrivacyPolicyToggle(e, "privacyPolicy")}>
                </DisplayUrlContent>
            )}

            {showMobileAppSuggestion && (
                <AlertModal
                    show={showMobileAppSuggestion}
                    title='Device Compatibility Notice'
                    closeOnClickOutside={false}
                    showConfirm={false}
                    onCancel={onCancelMobileAppSuggestion}
                >
                    <MobileAppSuggestionsModal />
                </AlertModal>
            )}
        </div>
    );
}

export default SignUp;
